export const subAdminConstants = {
 
   ADD_SUBADMIN_REQUEST:      'ADD_SUBADMIN_REQUEST',
   ADD_SUBADMIN_SUCCESS:      'ADD_SUBADMIN_SUCCESS',
   ADD_SUBADMIN_FAILURE:      'ADD_SUBADMIN_FAILURE',
   GET_USERLIST_REQUEST:      'GET_USERLIST_REQUEST',
   GET_USERLIST_SUCCESS:      'GET_USERLIST_SUCCESS',
   GET_USERLIST_FAILURE:      'GET_USERLIST_FAILURE',
   DELETE_USER_REQUEST:       'DELETE_USER_REQUEST',
   DELETE_USER_SUCCESS:       'DELETE_USER_SUCCESS',
   DELETE_USER_FAILURE:       'DELETE_USER_FAILURE',
   UPDATE_USER_REQUEST:       'UPDATE_USER_REQUEST',
   UPDATE_USER_SUCCESS:       'UPDATE_USER_SUCCESS',
   UPDATE_USER_FAILURE:       'UPDATE_USER_FAILURE',
   GET_USER_DETAILS_REQUEST:  'GET_USER_DETAILS_REQUEST',
   GET_USER_DETAILS_SUCCESS:  'GET_USER_DETAILS_SUCCESS',
   GET_USER_DETAILS_FAILURE:  'GET_USER_DETAILS_FAILURE',
      GET_AFUSER_DETAILS_REQUEST:  'GET_AFUSER_DETAILS_REQUEST',
   GET_AFUSER_DETAILS_SUCCESS:  'GET_AFUSER_DETAILS_SUCCESS',
   GET_AFUSER_DETAILS_FAILURE:  'GET_AFUSER_DETAILS_FAILURE',
   POST_STORE_CREDIT_REQUEST: 'POST_STORE_CREDIT_REQUEST',
   POST_STORE_CREDIT_SUCCESS: 'POST_STORE_CREDIT_SUCCESS',
   POST_STORE_CREDIT_FAILURE: 'POST_STORE_CREDIT_FAILURE',
   GET_STORE_CREDIT_REQUEST:  'GET_STORE_CREDIT_REQUEST',
   GET_STORE_CREDIT_SUCCESS:  'GET_STORE_CREDIT_SUCCESS',
   GET_STORE_CREDIT_FAILURE:  'GET_STORE_CREDIT_FAILURE',

   GET_PERMISSIONLIST_REQUEST:  'GET_PERMISSIONLIST_REQUEST',
   GET_PERMISSIONLIST_SUCCESS:  'GET_PERMISSIONLIST_SUCCESS',
   GET_PERMISSIONLIST_FAILURE:  'GET_PERMISSIONLIST_FAILURE',

   SAVE_PERMISSION_REQUEST:  'SAVE_PERMISSION_REQUEST',
   SAVE_PERMISSION_SUCCESS:  'SAVE_PERMISSION_SUCCESS',
   SAVE_PERMISSION_FAILURE:  'SAVE_PERMISSION_FAILURE'
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/subAdminConstants.js